import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ProgramDetailDataObject } from 'models/service';

type GetProgramRouteParams = {
  id: string;
};

export const getProgram = async ({ routeParams: { id } }: RouteParamsRequest<GetProgramRouteParams>) =>
  apiClient.get<ProgramDetailDataObject, ApiClientResponse<ProgramDetailDataObject>>(routes.program.get(id));
